import React, { useContext } from 'react';
import { Nav, Card } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaTelegram } from 'react-icons/fa';
import usePermissions, { PERMISSIONS } from '../hooks/usePermissions';
import AuthContext from '../context/AuthContext';
// ⚠ Temporal: selector de paleta. Ver src/theme/.
import { useTheme } from '../theme/ThemeContext';

const SettingsMenu = () => {
    const { user } = useContext(AuthContext);
    const { hasPermission } = usePermissions(user);
    const { t } = useTranslation();
    const location = useLocation();
    const canManageUsers = hasPermission(PERMISSIONS.MANAGE_USERS);
    const canViewBusinessSettings = hasPermission(PERMISSIONS.VIEW_BUSINESS_SETTINGS);
    const canManagePlan = ['owner', 'superadmin'].includes(user?.role);
    const { canChoose: canChooseTheme } = useTheme();

    const isActive = (path) => location.pathname === path;

    return (
        <Card>
            <Card.Body>
                <Nav variant="pills" className="flex-column">
                    <Nav.Link as={Link} to="/settings/profile" active={isActive('/settings/profile')}>
                        {t('settings.profile')}
                    </Nav.Link>
                    {canViewBusinessSettings && (
                        <Nav.Link as={Link} to="/settings/business" active={isActive('/settings/business')}>
                            {t('settings.business')}
                        </Nav.Link>
                    )}
                    {canManagePlan && (
                        <Nav.Link as={Link} to="/settings/plan" active={isActive('/settings/plan')}>
                            {t('settings.planManagement')}
                        </Nav.Link>
                    )}
                    {canManageUsers && (
                        <Nav.Link as={Link} to="/settings/users" active={isActive('/settings/users')}>
                            {t('settings.userManagement')}
                        </Nav.Link>
                    )}
                    <Nav.Link as={Link} to="/settings/change-password" active={isActive('/settings/change-password')}>
                        {t('settings.changePassword')}
                    </Nav.Link>
                    {/* ⚠ Temporal: sin control de permisos a propósito — la idea es que
                        cualquiera pueda probar las paletas y opinar. Desaparece si el
                        superadmin cierra la elección desde el backoffice. Ver src/theme/. */}
                    {canChooseTheme && (
                        <Nav.Link as={Link} to="/settings/appearance" active={isActive('/settings/appearance')}>
                            {t('settings.appearance')}
                        </Nav.Link>
                    )}
                    {canViewBusinessSettings && (
                        <Nav.Link as={Link} to="/settings/telegram" active={isActive('/settings/telegram')}>
                            <FaTelegram className="me-1" />
                            Bot de Telegram
                        </Nav.Link>
                    )}
                    {canViewBusinessSettings && (
                        <Nav.Link as={Link} to="/settings/tables" active={isActive('/settings/tables')}>
                            {t('settings.tables')}
                        </Nav.Link>
                    )}
                    <Nav.Link as={Link} to="/settings/legal" active={isActive('/settings/legal')}>
                        {t('settings.legal')}
                    </Nav.Link>
                </Nav>
            </Card.Body>
        </Card>
    );
};

export default SettingsMenu;